import React from "react";
import { ICSVModifier } from "modules/Purchases/models/ICSVaditives";
import { IPurchaseCSVErrors } from "views/PurchaseViews/PurchaseUploaderHelper/IPurchaseCSVErrors";
import { SBTranslate } from "i18n";
import { IPurchasePlan } from "modules/Purchases/models/IPurchasePlans";

export const processCSV = (
	file: File,
	callback: (validData: ICSVModifier[], hasErrors: boolean) => void,
	setErrorDetails: React.Dispatch<React.SetStateAction<IPurchaseCSVErrors[]>>,
	setValidData: React.Dispatch<React.SetStateAction<ICSVModifier[]>>,
	rows: IPurchasePlan[]
): void => {
	const reader = new FileReader();
	reader.onload = (e: ProgressEvent<FileReader>) => {
		const text = e.target?.result as string;
		const { validData, hasErrors, errorDetails } = parseAndProcessCSV(
			text,
			rows
		);

		setValidData(validData);
		if (hasErrors) {
			setErrorDetails(errorDetails);
		}
		callback(validData, hasErrors);
	};
	reader.onerror = () => {};
	reader.readAsText(file);
};

const parseAndProcessCSV = (
	csvText: string,
	rows: IPurchasePlan[]
): {
	validData: ICSVModifier[];
	hasErrors: boolean;
	errorDetails: IPurchaseCSVErrors[];
} => {
	let hasErrors = false;
	const validData: ICSVModifier[] = [];
	const errorDetails: IPurchaseCSVErrors[] = [];

	const existingIds = new Set(
		rows.map(
			(row) =>
				`${row.inventory.product.clientID}-${row.inventory.store.clientID}`
		)
	);

	csvText
		.split("\n")
		.slice(1)
		.forEach((row) => {
			const trimmedRow = row.trim();
			if (!trimmedRow) return;

			const columns = trimmedRow.split(SBTranslate("csvSeparator"));
			if (columns.length === 3) {
				const [productClientID, storeClientID, modifierStr] =
					columns.map((col) => col.trim());
				const modifier = parseInt(modifierStr, 10);

				if (
					!isNaN(modifier) &&
					existingIds.has(`${productClientID}-${storeClientID}`)
				) {
					validData.push({
						productClientID,
						storeClientID,
						modifier,
					});
				} else {
					hasErrors = true;
					errorDetails.push({
						productClientID,
						storeClientID,
						modifier: isNaN(modifier) ? 0 : modifier,
						errorMessage: !isNaN(modifier)
							? SBTranslate("noMatchingProductStore")
							: SBTranslate("modifierMustBeInteger"),
					});
				}
			} else {
				hasErrors = true;
				errorDetails.push({
					productClientID: "",
					storeClientID: "",
					modifier: 0,
					errorMessage: SBTranslate("incorrectCSVFormat"),
				});
			}
		});

	return { validData, hasErrors, errorDetails };
};

export const handleCSVError = (
	errorMessage: string,
	productClientID: string,
	storeClientID: string,
	setModalErrors: React.Dispatch<React.SetStateAction<IPurchaseCSVErrors[]>>,
	setIsErrorModalOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
	const newError = {
		productClientID,
		storeClientID,
		modifier: 0,
		errorMessage,
	};

	setModalErrors((prevErrors) => [...prevErrors, newError]);
	setIsErrorModalOpen(true);
};
